<div class="layout-footer">
  <div class="footer-content">
    <span>Todos los derechos reservados MindX Corp {{ currentYear }}</span>
<!--    <span>Desarrollado con <span class="heart-icon">❤️</span> por</span>
    <a href="https://axd.com.co" target="_blank" rel="noopener noreferrer"
      aria-label="Visitar sitio web de Axede S.A">
      AXD S.A
    </a>
    <span>para el mundo</span>
  <span class="footer-version" *ngIf="appVersion">v{{ appVersion }}</span>-->
  </div>
  <div class="social-links" *ngIf="showSocialLinks">
    <a href="https://linkedin.com/company/axede" target="_blank" rel="noopener noreferrer" aria-label="Axede LinkedIn">
      <i class="pi pi-linkedin"></i>
    </a>
  </div>
</div>
